import { isNotEmptyOrNull, isObject } from "../utils/common-utils";
import { answerEncryptText } from "./crypto";
import { getUserName } from "./TutorConstants";

export const getQuestionID = (questionData) => {
  return questionData.uuid;
};

export const getVersionUUID = (questionData) => {
  return questionData.version_uuid;
};

export const getQuestionType = (questionData) => {
  return questionData.question_type;
};
export const getQuestionAnswers = (questionData) => {
  return questionData.answers;
};

export const matchAnswer = (answers, ans) => {
  const index = answers.findIndex(
    (element) => element?.toLowerCase() === ans?.toLowerCase()
  );
  return index !== -1;
};

export const timeToSeconds = (timeString) => {
  if (timeString.toString().split(":").map(Number).length === 3) {
    const [hours, minutes, seconds] = timeString
      .toString()
      .split(":")
      .map(Number);
    return hours * 3600 + minutes * 60 + seconds;
  } else if (timeString.toString().split(":").map(Number).length === 2) {
    const [minutes, seconds] = timeString.toString().split(":").map(Number);
    return minutes * 60 + seconds;
  }
};

export function concatenateStrings(strings, concatFunction) {
  return concatFunction(strings);
}

// Example of a concatenation function
export function joinWithNextLine(strings) {
  return strings.join("\n");
}

export const getFormattedAnswer = (answerData) => {
  let formatedAnswer = "";
  console.log("input" + answerData);
  if (answerData.length > 1) {
    {
      answerData.map((item) =>
        isNotEmptyOrNull(formatedAnswer)
          ? (formatedAnswer = formatedAnswer + "\n" + item)
          : (formatedAnswer = item)
      );
    }
  } else {
    formatedAnswer = answerData[0];
  }

  return formatedAnswer;
};

export const fetchMPDAndExtractThumbnail = async () => {
  try {
    // Fetch the MPD file
    const response = await fetch(mpdUrl);
    const mpdContent = await response.text();

    // Parse the MPD file (using dash.js as an example)
    const dashParser = Dash.dependencies.DashParser();
    const parsedMPD = dashParser.parse(mpdContent);

    // Extract thumbnail URL (this is hypothetical and depends on your MPD structure)
    const thumbnailUrl = parsedMPD.getThumbnailUrl();

    // Set the thumbnail URL in the state
    return thumbnailUrl;
  } catch (error) {
    console.error("Error fetching or parsing MPD:", error);
  }
};

const shuffleArray = (array) => {
  return array.slice().sort(() => Math.random() - 0.5);
};

export const convertToHashAnswers = (answerArray) => {
  if (isNotEmptyOrNull(answerArray)) {
    let hashedAnswersArray = [];
    if (Array.isArray(answerArray) && answerArray.length > 0) {
      answerArray?.map((item) => [
        ...hashedAnswersArray,
        answerEncryptText(item),
      ]);
    }
    return hashedAnswersArray;
  }
};

const findOriginalAnswer = (hasedAnswer, optionsLayout) => {
  return optionsLayout?.find((item) => answerEncryptText(item) === hasedAnswer);
};

export const matchFibAnswers = (
  answers,
  ans,
  time_diff,
  hasHashedAnswer,
  optionsLayout,
  hasIndexedHashedAnswer
) => {
  const fibObject = {};
  const ansArray = [];

  for (let i = 0; i < answers.length; i++) {
    const { [i]: answer = "" } = ans;
    const isCorrect =
      answers[i]?.toLowerCase() ===
      (hasIndexedHashedAnswer
        ? answer?.toLowerCase()
        : hasHashedAnswer
        ? answerEncryptText(answer).toLowerCase()
        : answer?.toLowerCase());
    // twoStrings(answers[i]?.toLowerCase(), answer?.toLowerCase()) > 0.8;

    ansArray.push({
      actualAnswer: hasIndexedHashedAnswer
        ? answers[i]
        : hasHashedAnswer
        ? findOriginalAnswer(answers[i], optionsLayout)
        : answers[i],
      givenAnswer: answer,
      isCorrect,
      time_taken: time_diff,
    });
  }
  if (ans.length > ansArray.length) {
    for (let i = ansArray.length; i < ans.length; i++) {
      ansArray.push({
        actualAnswer: "na",
        givenAnswer: ans[i],
        isCorrect: false,
        time_taken: time_diff,
      });
    }
  }

  const result = ansArray.some((element) => !element.isCorrect);

  fibObject.answerResult = ansArray;
  fibObject.overAllResult = !result;

  return fibObject;
};

const twoStrings = (sa1, sa2) => {
  // Compare two strings to see how similar they are.
  // Answer is returned as a value from 0 - 1
  // 1 indicates a perfect similarity (100%) while 0 indicates no similarity (0%)
  // The algorithm is an n-gram comparison of bigrams of characters in a string

  // Comparison should not check case or whitespace
  let s1 = sa1.replace(/\s/g, "")?.toLowerCase();
  let s2 = sa2.replace(/\s/g, "")?.toLowerCase();
  if (s1.length === 1 || s2.length === 1) return Number(s1 === s2);
  const similarity_num = 2 * intersect(pairs(s1), pairs(s2)).length;
  const similarity_den = pairs(s1).length + pairs(s2).length;
  return similarity_num / similarity_den;
};

export const intersect = (arr1, arr2) => {
  let r = [],
    o = [],
    l = arr2.length,
    i,
    v;
  for (i = 0; i < l; i++) {
    o[arr2[i]] = true;
  }
  l = arr1.length;
  for (i = 0; i < l; i++) {
    v = arr1[i];
    if (v in o) {
      r.push(v);
    }
  }
  return r;
};

export const parseUserName = (text) => {
  if (text !== undefined) {
    return text.replace("@name", getUserName());
  }
};

export const pairs = (s) => {
  // Get an array of all pairs of adjacent letters in a string
  let pairs = [];
  for (let i = 0; i < s.length - 1; i++) {
    pairs[i] = s.slice(i, i + 2);
  }
  return pairs;
};

// Sort array with dice Comparator
export const simSort = (s1, arr1) => {
  // Comparison should not check case or whitespace
  return arr1.sort(function (a, b) {
    let v1 = twoStrings(s1, a);
    let v2 = twoStrings(s1, b);
    return v2 - v1;
  });
};

export const calculateProgress = (input) => {
  if (isNotEmptyOrNull(input) && input !== 0 && !isObject(input)) {
    const parts = input.split("/");

    if (parts.length === 2) {
      const numerator = parseInt(parts[0]);
      const denominator = parseInt(parts[1]);

      if (denominator !== 0) {
        const result = numerator / denominator;
        return result * 100;
      } else {
        return 0;
      }
    } else {
      return 0;
    }
  } else {
    return 0;
  }
};
